import React from 'react'
import {Dropdown, Table} from 'semantic-ui-react'
import AlmDropdown from '../../../componentes/AlmDropdown'
import {getCompanyCollection} from '../../../firebase'

class Inventario extends React.Component{
    constructor(props){
        super(props)
        this.database=null
        this.state={
            rows:[],
            wrh:'',
            ocultar: 'ocultar'
        }
    }
    async componentDidMount(){
        this.database = await getCompanyCollection('Inventario')
        if (this.state.wrh) this.listCompras()
    }
	componentWillUnmount(){
		if (this.unsubscribe) this.unsubscribe()
	}
    componentDidUpdate(prevProps, prevState){
        if(this.state.wrh!==prevState.wrh){
            this.listCompras()
        }
    }
    setReference=()=>{
        let dbReference=this.database
        dbReference=this.filterWrh(dbReference)
        return dbReference
    }
    filterWrh=dbReference=>{
        return dbReference.where('ubicacion', '==', this.state.wrh)   
    }
    listCompras=()=>{
        if (!this.database || !this.state.wrh) return
        if (this.unsubscribe) this.unsubscribe()
        this.unsubscribe = this.setReference().orderBy('clave', 'asc').onSnapshot(snap=>{
            const rows=[]
            for(let i=0; i<snap.docs.length;i++){
                rows.push(snap.docs[i].data())
            }
            this.setState({
                rows:rows
            })
        })
    }
    handlewrhChange=(e, {value})=>{
        this.setState({wrh:value})
    }
    handleOculChange=(e, {value})=>{
        this.setState({ocultar:value})
    }
    render(){
        return(
        <>
        <div className="filtros">
            <div>
                <div>Seleccione almacén</div>
                <AlmDropdown
                fluid selection search
                value={this.state.wrh} onChange={this.handlewrhChange} 
                placeholder='Almacén' />
            </div>
            <div >
                <div>Mostrar Agotados?</div>
                <Dropdown
                    fluid
                    selection
                    options={[
                        {key:1, text:'Si', value:'mostrar'},
                        {key:2, text:'No', value:'ocultar'},
                    ]}
                    name='ocultar'
                    value={this.state.ocultar}
                    onChange={this.handleOculChange}
                />
            </div>
        </div>
        <div  className="body tabla">
            <table><tbody>
            <tr>
                <th>Nombre</th>
                <th>Tipo</th>
                <th>Cantidad</th>
                <th>Unidades</th>
            </tr>
            {this.state.rows.map((row, i)=>{
                if (row.enInventario > 0){
                    i++
                    return(
                        <Table.Row key={i}>
                            <Table.Cell>{row.nombre}</Table.Cell>
                            <Table.Cell>{row.tipo}</Table.Cell>
                            <Table.Cell>{row.enInventario}</Table.Cell>
                            <Table.Cell>{row.unidades}</Table.Cell>
                        </Table.Row>
                    )
                } else if (this.state.ocultar === "mostrar"){
                    i++
                    return(
                        <Table.Row key={i}>
                            <Table.Cell>{row.clave}</Table.Cell>
                            <Table.Cell>{row.tipo}</Table.Cell>
                            <Table.Cell>{row.enInventario}</Table.Cell>
                            <Table.Cell>{row.unidades}</Table.Cell>
                        </Table.Row>
                    )
                }
            })}
            </tbody></table>
        </div>
        </>
        )
    }
}

export default Inventario
